import { Input, Component } from '@angular/core';

@Component({
	selector: 'app-email-client-support',
	templateUrl: './email-client-support.component.html',
	styleUrls: ['./email-client-support.component.scss']
})
export class EmailClientSupportComponent {
	@Input() support;

	constructor() {}
}
